import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de/translation.json';
import en from './locales/en/translation.json';

const savedLang = (() => {
  try {
    const v = localStorage.getItem('lang');
    if (v === 'de' || v === 'en') return v;
  } catch {}
  return 'de';
})();

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

try {
  i18n.on('languageChanged', (lng) => {
    try { localStorage.setItem('lang', lng); } catch {}
  });
} catch {}

export default i18n;